var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-city"
  }, [_c('div', {
    staticClass: "address",
    style: {
      height: _vm.buttonHeight + 'px',
      'line-height': _vm.buttonHeight + 'px'
    },
    on: {
      "click": function click($event) {
        return _vm.showCityDialog();
      }
    }
  }, [_c('ycf-svg', {
    staticStyle: {
      "margin-right": "2px"
    },
    attrs: {
      "icon-name": "nav_location_icon"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.currentCity.districtName,
      expression: "!currentCity.districtName"
    }]
  }, [_vm._v(_vm._s(_vm._showCity(_vm.currentCity.cityName)))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentCity.districtName,
      expression: "currentCity.districtName"
    }]
  }, [_vm._v(_vm._s(_vm._showCity(_vm.currentCity.districtName)))]), _vm.isShowIcon ? _c('ycf-svg', {
    staticClass: "jiantou-icon",
    attrs: {
      "icon-name": "tongyong_jiantou_xiangxia"
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.nowEditCity.showDialog,
      expression: "nowEditCity.showDialog"
    }],
    staticClass: "city-dialog",
    style: {
      height: _vm.dialogHeight + 'px'
    },
    attrs: {
      "id": "componentCityDislog"
    }
  }, [_c('div', {
    staticClass: "overlay",
    class: {
      'show-content': _vm.nowEditCity.showDialogContent
    },
    on: {
      "click": function click($event) {
        return _vm.showCityDialog();
      }
    }
  }), _c('div', {
    staticClass: "outer-box",
    style: {
      height: _vm.dialogHeight + 'px',
      left: _vm.nowEditCity.showDialogContent ? '0' : '-100%'
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "return-btn",
    on: {
      "click": _vm.toggleShowDialog
    }
  }, [_c('ycf-svg', {
    staticClass: "iconfont",
    attrs: {
      "icon-name": "arrowright"
    }
  })], 1), _c('div', {
    staticClass: "input-box"
  }, [_c('ycf-svg', {
    staticClass: "search-icon iconfont",
    attrs: {
      "icon-name": "sousuoicon"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.cityKeyWords,
      expression: "cityKeyWords"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autofocus": "true"
    },
    domProps: {
      "value": _vm.cityKeyWords
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.cityKeyWords = $event.target.value;
      }, _vm.handleInput]
    }
  }), _c('ycf-svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.cityKeyWords.length > 0,
      expression: "cityKeyWords.length > 0"
    }],
    staticClass: "search-clean-btn iconfont",
    attrs: {
      "icon-name": "error_icon"
    },
    on: {
      "click": _vm.cleanInput
    }
  })], 1)]), _vm.showCityMask ? _c('div', {
    staticClass: "city-mask"
  }, [_vm.results.length ? _c('div', {
    staticClass: "tips"
  }, [_vm._v("搜索结果")]) : _vm._e(), _vm.results.length ? _c('div', {
    staticClass: "search-city-wrap"
  }, _vm._l(_vm.results, function (item) {
    return _c('div', {
      key: item.cityCode,
      staticClass: "search-city-item",
      on: {
        "click": function click($event) {
          return _vm.handleSelectCity(item);
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.searchName) + "\n          ")]);
  }), 0) : _c('div', {
    staticClass: "no-result-tips"
  }, [_vm._v("暂无相关城市")])]) : [_c('div', {
    staticClass: "dialog-address-title",
    on: {
      "click": function click($event) {
        return _vm.testCurLocation();
      }
    }
  }, [_c('div', {
    staticClass: "dialog-address"
  }, [_vm._v("\n            当前区域："), _c('strong', [_vm._v(_vm._s(_vm._f("_showCurrentCity")(_vm.currentCity.cityName)) + _vm._s(_vm._showDistrict(_vm.currentCity.districtName)))])]), _c('div', {
    staticClass: "show-district-btn",
    on: {
      "click": function click($event) {
        return _vm.setDistrictShow();
      }
    }
  }, [_c('span', [_vm._v("切换区县")]), _vm.districtBox.show ? _c('ycf-svg', {
    attrs: {
      "icon-name": "retract"
    }
  }) : _c('ycf-svg', {
    attrs: {
      "icon-name": "open"
    }
  })], 1)]), _c('div', {
    staticClass: "district-box",
    style: {
      height: _vm.districtBox.show ? _vm.districtBox.height + 'px' : '0'
    }
  }, [_c('div', {
    staticClass: "district-list",
    style: {
      top: _vm.districtBox.show ? '0' : '-' + _vm.districtBox.height + 'px'
    },
    attrs: {
      "id": "componentCityDistrictList"
    }
  }, [_c('div', {
    staticClass: "district-item",
    class: {
      selected: _vm.currentCity.districtCode == ''
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.selectDistrict();
      }
    }
  }, [_c('div', {
    staticClass: "item-block"
  }, [_vm._v("全城")])]), _vm._l(_vm.nowEditCity.districtList, function (district, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.nowEditCity.districtList.length > 0,
        expression: "nowEditCity.districtList.length > 0"
      }],
      key: index,
      staticClass: "district-item",
      class: {
        selected: district.districtCode == _vm.currentCity.districtCode
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectDistrict(district);
        }
      }
    }, [_c('div', {
      staticClass: "item-block"
    }, [_vm._v(_vm._s(district.districtName))])]);
  })], 2)]), _c('div', {
    staticClass: "area"
  }, [_c('div', {
    staticClass: "area-content"
  }, [_c('div', {
    staticClass: "tag-body province-box",
    attrs: {
      "id": "provinceBox"
    },
    on: {
      "scroll": function scroll($event) {
        $event.stopPropagation();
        return _vm.provinseBoxScroll();
      }
    }
  }, [_c('ul', {
    staticClass: "tag-block province-list"
  }, _vm._l(_vm.provinceList, function (province, index) {
    return _c('li', {
      key: index,
      staticClass: "list-item",
      class: {
        selected: province.provinceCode == _vm.nowEditProvince.provinceCode
      },
      attrs: {
        "id": 'province_' + province.provinceCode
      },
      on: {
        "click": function click($event) {
          return _vm.selectProvince(province);
        }
      }
    }, [_vm._v("\n                  " + _vm._s(province.provinceName) + "\n                ")]);
  }), 0)]), _c('div', {
    staticClass: "tag-body city-box",
    attrs: {
      "id": "cityBox"
    },
    on: {
      "scroll": function scroll($event) {
        $event.stopPropagation();
        return _vm.cityBoxScroll();
      }
    }
  }, [_vm.nowEditProvince.provinceCode == 100 ? _c('div', {
    staticClass: "tag-block"
  }, [_c('div', [_c('p', {
    staticClass: "hot-title"
  }, [_vm._v("常用")]), _c('ul', {
    staticClass: "hot-block"
  }, _vm._l(_vm.nowEditProvince.cityList, function (city, index) {
    return _c('li', {
      key: index,
      staticClass: "hot-item",
      class: {
        selected: city.cityCode == _vm.nowEditCity.cityCode
      },
      attrs: {
        "id": 'city_' + city.cityCode
      },
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'city_common');
        }
      }
    }, [_c('div', {
      staticClass: "item-block"
    }, [_c('ycf-svg', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: city.cityName == _vm.localCity.cityName,
        expression: "city.cityName == localCity.cityName"
      }],
      staticClass: "home_list_location_i",
      attrs: {
        "icon-name": "home_list_location_i"
      }
    }), _vm._v(_vm._s(city.cityName) + "\n                      ")], 1)]);
  }), 0)]), _vm.hotCityList.length > 0 ? _c('div', [_c('p', {
    staticClass: "hot-title"
  }, [_vm._v("热门")]), _c('ul', {
    staticClass: "hot-block"
  }, _vm._l(_vm.hotCityList, function (city, index) {
    return _c('li', {
      key: index,
      staticClass: "hot-item",
      class: {
        selected: city.cityCode == _vm.nowEditCity.cityCode
      },
      attrs: {
        "id": 'city_' + city.cityCode
      },
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'city_hot');
        }
      }
    }, [_c('div', {
      staticClass: "item-block"
    }, [_vm._v(_vm._s(city.cityName))])]);
  }), 0)]) : _vm._e()]) : _c('ul', {
    staticClass: "tag-block city-list"
  }, _vm._l(_vm.nowEditProvince.cityList, function (city, index) {
    return _c('li', {
      key: index,
      staticClass: "list-item",
      class: {
        selected: city.cityCode == _vm.nowEditCity.cityCode
      },
      attrs: {
        "id": 'city_' + city.cityCode
      },
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'city_county');
        }
      }
    }, [_vm._v("\n                  " + _vm._s(city.cityName) + "\n                  "), _c('ycf-svg', {
      staticClass: "svgSelected",
      attrs: {
        "icon-name": "selected"
      }
    })], 1);
  }), 0)])])])]], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };